<template>
<div>
<iframe src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=12&l=ur1&category=fashion&banner=0GVG9N0ZQRAT1WMZ2PR2&f=ifr&linkID=188c555005663e0afe3658f41ef07ed4&t=muggytea0f-22&tracking_id=muggytea0f-22" width="300" height="250" scrolling="no" border="0" marginwidth="0" style="border:none;" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>
</div>
</template>

<script>
export default {
    name: 'AmazonAdSence',
}
</script>


// WEBPACK FOOTER //
// src/components/common/AmazonAdSense.vue